import { createRouter, createWebHistory } from "vue-router";
import store from "../store";

// Import views
import Login from "../views/Login.vue";
import Dashboard from "../views/Dashboard.vue";
import Inbox from "../views/Inbox.vue";
import ConversationView from "../views/ConversationView.vue";

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { requiresAuth: false },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/inbox/:id",
    name: "Inbox",
    component: Inbox,
    meta: { requiresAuth: true },
  },
  {
    path: "/conversation/:conversationId",
    name: "ConversationView",
    component: ConversationView,
    meta: { requiresAuth: true },
  },
  {
    // Catch all route for 404
    path: "/:pathMatch(.*)*",
    redirect: "/dashboard",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Navigation guard to check authentication
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const isAuthenticated = store.getters.isAuthenticated;

  if (requiresAuth && !isAuthenticated) {
    // Redirect to login if trying to access protected route without auth
    next({
      name: "Login",
      query: { redirect: to.fullPath },
    });
  } else if (to.name === "Login" && isAuthenticated) {
    // Redirect to dashboard if trying to access login while already authenticated
    next({ name: "Dashboard" });
  } else {
    // Proceed as normal
    next();
  }
});

export default router;
